import { compact, uniq } from "lodash";

import { getWatchedQuery } from "@graphql/client";

import getAlignmentGoalsQuery from "./graphql/get-alignment-goals-query";
import { AlignedGoalType } from "./use-fetch-alignment-goals";

export const refreshAlignmentOfGoalIds = (
  goalIds: (number | undefined | boolean | null)[],
) => {
  const watchedQuery = getWatchedQuery(getAlignmentGoalsQuery);
  const goalIdsToRefresh = uniq(compact(goalIds));
  if (watchedQuery && goalIdsToRefresh.length > 0) {
    watchedQuery.fetchMore({
      variables: {
        idsToMergeInApolloCache: goalIdsToRefresh,
        merge: true,
      },
    });
  }
};

export type AlignmentGoalsByIdType = {
  [key: number]: AlignedGoalType;
};

export type AlignmentChildGoalIdsByParentIdType = {
  [key: number]: number[];
};

export const getGoalDescendantIds = (
  goalId: number,
  allChildGoalIdsByParentId: AlignmentChildGoalIdsByParentIdType,
): number[] => {
  const childGoalIds = allChildGoalIdsByParentId[goalId];
  if (!childGoalIds) return [];
  return childGoalIds.concat(
    ...childGoalIds.map((childGoalId) =>
      getGoalDescendantIds(childGoalId, allChildGoalIdsByParentId),
    ),
  );
};

export const isGoalInSearchResultPath = (
  goalId: number,
  searchResultGoalIds?: number[],
  goalIdsInSearchResultPaths?: number[],
) => {
  return (
    searchResultGoalIds === undefined ||
    goalIdsInSearchResultPaths === undefined ||
    searchResultGoalIds?.includes(goalId) ||
    goalIdsInSearchResultPaths?.includes(goalId)
  );
};
